export const ndisNumberRegex = /^\d{9,10}$/;
